import { CommandTemplateClient } from "@formant/core/client/CommandTemplateClient";
import { IRequestToken } from "@formant/core/model/IRequestToken";
import { Uuid } from "@formant/core/model/Uuid";

export interface ICommandTemplateRank {
    id: Uuid;
    displayOrder: number;
}

/**
 * Extends the @formant/core client with the bulk reorder endpoint so a drag
 * persists in one transactional request instead of one PATCH per template.
 * Belongs in @formant/core alongside the other CommandTemplateClient methods
 * once that package ships it.
 */
export class ReorderableCommandTemplateClient extends CommandTemplateClient {
    public async reorder(
        token: string | IRequestToken,
        items: ICommandTemplateRank[],
    ): Promise<void> {
        await this.fetch("command-templates/reorder", {
            token,
            method: "POST",
            body: { items },
            allowUnsafeRetries: true,
        });
    }
}
